/**
 * Created by USER on 18/9/10.
 */

import React, { Component } from 'react';

export default class SingleBanner extends Component {
  constructor(props) {
    super(props)
  }
  linkTo(link) {
    this.props.history.push(link);
  }
  render() {
    const {background, link} = this.props;
    return (
      <div
        style={{
          backgroundImage: `url(${background})`
        }}
        onClick={() => this.linkTo(link)}
      >
      </div>
    )
  }
}
